// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import i18n from './lang/lang'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import Bus from '@/components/ControlBus'
import '@/utils/filters'
import '@/utils/directives'
import {sentryUrl, sentryActive} from '@/utils/constants'
// import {version} from '@/../static/version.json'

import '../node_modules/video.js/dist/video-js.css'
// import '../node_modules/videojs-contrib-ads/dist/videojs.ads.css'
// import '../node_modules/videojs-seek-buttons/dist/videojs-seek-buttons.css'
import '@/assets/css/videojs.custom.css'
import '@/styles.sass'
import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/shopping-cart'
import 'vue-awesome/icons/sign-in-alt'
import 'vue-awesome/icons/user-plus'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/sign-out-alt'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/id-card'
import 'vue-awesome/icons/sync'
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/caret-right'
import 'vue-awesome/icons/caret-left'
import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/chevron-left'
import 'vue-awesome/icons/play'
import 'vue-awesome/icons/ticket-alt'
import 'vue-awesome/icons/rss'
// import 'vue-awesome/icons/backward'
// import 'vue-awesome/icons/forward'
import 'vue-awesome/icons/step-forward'
import 'vue-awesome/icons/mobile-alt'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/regular/play-circle'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/regular/heart'
import 'vue-awesome/icons/heart'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/volume-up'
import 'vue-awesome/icons/volume-mute'
import 'vue-awesome/icons/brands/apple'
import 'vue-awesome/icons/brands/android'
import 'vue-awesome/icons/times-circle'

import Icon from 'vue-awesome/components/Icon'

require('@/materialize.config.scss')

Vue.component('icon', Icon)

Vue.config.productionTip = false

// sentry
if (sentryActive && process.env.NODE_ENV !== 'development') {
  Raven
    .config(sentryUrl)
    .addPlugin(RavenVue, Vue)
    // .setExtraContext({version: version})
    .install()
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
  beforeCreate: function () {
    const localeBrowser = navigator.language || navigator.userLanguage
    if (localeBrowser.substring(0, 2) in this.$i18n.messages) {
      let locale = localeBrowser.substring(0, 2)
      document.documentElement.lang = locale
      this.$i18n.locale = locale
    }
  },
  mounted: function () {
    window.addEventListener('keyup', function (event) {
      switch (event.keyCode) {
        // BACK
        case 27: // web
        case 10009: // default
        case 461: // LG
          Bus.$emit('key-back')
          break

        // ENTER
        case 13:
        case 29443:
          Bus.$emit('key-enter')
          break

        // PlayPause
        case 10252:
          Bus.$emit('key-play-pause')
          break

        // Pause
        case 19:
          Bus.$emit('key-pause')
          break

        // Play
        case 415:
          Bus.$emit('key-play')
          break

        // STOP
        case 413:
          Bus.$emit('key-stop')
          break

        // Rewind <<
        case 412:
          Bus.$emit('key-rewind')
          break

        // Forward >>
        case 417:
          Bus.$emit('key-forward')
          break

        // LEFT
        case 37:
        case 4:
          Bus.$emit('key-left')
          break

        // UP
        case 38:
          Bus.$emit('key-up')
          break

        // RIGHT
        case 39:
        case 5:
          Bus.$emit('key-right')
          break

        // DOWN
        case 40:
          Bus.$emit('key-down')
          break

        // RED
        case 403:
          Bus.$emit('key-red')
          break

        // GREEN
        case 404:
          Bus.$emit('key-green')
          break

        // YELLOW
        case 405:
          Bus.$emit('key-yellow')
          break

        // BLUE
        case 406:
          Bus.$emit('key-blue')
          break

        // SAMSUNG IME DONE
        case 65376:
          Bus.$emit('key-ime-done')
          break

        // SAMSUNG IME DONE
        case 65385:
          Bus.$emit('key-ime-cancel')
          break
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js